import React from 'react';
import RadixMenu from '../../Common/RadixMenu/RadixMenu';
import {
    EllipsisVerticalIcon,
    ShoppingCartIcon,
    PencilIcon,
    PaperAirplaneIcon,
    CheckCircleIcon,
    DocumentDuplicateIcon,
    TrashIcon
} from '@heroicons/react/24/outline';

const CapsuleActionsRadixMenu = ({
    capsule,
    onOrder,
    onEdit,
    onSendEmail,
    onValidate,
    onDuplicate,
    onDelete,
    isMobile = false,
    className = ''
}) => {
    // Actions rapides pour mobile
    const quickActions = [
        {
            label: "Commander",
            icon: <ShoppingCartIcon className="w-4 h-4" />,
            onClick: onOrder,
            className: "btn btn-primary btn-sm btn-circle"
        },
        {
            label: "Modifier",
            icon: <PencilIcon className="w-4 h-4" />,
            onClick: onEdit,
            className: "btn btn-primary btn-sm btn-circle"
        }
    ];

    // Actions du menu déroulant
    const menuItems = [
        // Actions principales (masquées sur mobile car disponibles en boutons rapides)
        {
            label: "Commander",
            icon: <ShoppingCartIcon className="w-4 h-4" />,
            onClick: onOrder,
            className: "lg:flex hidden"
        },
        {
            label: "Modifier",
            icon: <PencilIcon className="w-4 h-4" />,
            onClick: onEdit,
            className: "lg:flex hidden"
        },
        { divider: true },
        // Actions secondaires (toujours visibles)
        {
            label: "Envoyer par email",
            icon: <PaperAirplaneIcon className="w-4 h-4" />,
            onClick: onSendEmail
        },
        {
            label: "Valider",
            icon: <CheckCircleIcon className="w-4 h-4" />,
            onClick: onValidate
        },
        {
            label: "Dupliquer",
            icon: <DocumentDuplicateIcon className="w-4 h-4" />,
            onClick: onDuplicate
        },
        { divider: true },
        {
            label: "Supprimer",
            icon: <TrashIcon className="w-4 h-4" />,
            onClick: onDelete,
            danger: true
        }
    ];

    // Trigger du menu
    const trigger = (
        <button className={`btn btn-primary btn-sm btn-circle relative ${className ? className : ''}`}>
            <EllipsisVerticalIcon className="w-6 h-6 transition-all" />
        </button>
    );

    return (
        <div className="flex items-center gap-1">
            {/* Actions rapides pour mobile */}
            {isMobile && (
                <div className="flex items-center gap-1 mr-1">
                    {quickActions.map((action, index) => (
                        <div key={index} className="tooltip tooltip-bottom" data-tip={action.label}>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    action.onClick();
                                }}
                                className={action.className}
                            >
                                {action.icon}
                            </button>
                        </div>
                    ))}
                </div>
            )}

            {/* Menu déroulant Radix */}
            <RadixMenu
                trigger={trigger}
                items={menuItems}
                side="bottom"
                align="end"
                width="w-52 sm:w-56"
            />
        </div>
    );
};

export default CapsuleActionsRadixMenu; 